<template>
  <v-list
    nav
  >
    <div
      v-for="item of menuItems"
      :key="item.title"
    >
      <div v-if="isAdmin || !item.accessTypes || item.accessTypes.includes(accessType)">
        <template v-if="item.items">
          <v-list-group
            v-model="item.active"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-icon v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </template>
            <div
              v-for="child in item.items"
              :key="child.title"
            >
              <v-list-item
                v-if="isAdmin || !child.accessTypes || child.accessTypes.includes(accessType)"
                :to="child.to"
                class="pl-5"
              >
                <v-list-item-icon v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title v-text="child.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-list-group>
        </template>
        <template v-else>
          <v-list-item :to="item.to">
            <v-list-item-icon v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </div>
    </div>
  </v-list>
</template>

<script>
import { AccessType } from '@mymsa/common'

const menuItems = [
  {
    title: 'Members',
    icon: 'card_membership',
    accessTypes: [AccessType.STAFF, AccessType.AUS_MEAT],
    items: [
      {
        title: 'Registrations',
        icon: 'business',
        accessTypes: [AccessType.STAFF, AccessType.AUS_MEAT],
        to: { name: 'AdminRegistrationList' }
      },
      {
        title: 'Member People',
        icon: 'groups',
        accessTypes: [AccessType.STAFF],
        to: { name: 'AdminRegistrationPersonList' }
      },
      {
        title: 'AUS-MEAT Companies',
        icon: 'store',
        accessTypes: [AccessType.STAFF],
        to: { name: 'AdminAusMeatCompanyList' }
      }
    ]
  },
  {
    title: 'People',
    icon: 'person',
    accessTypes: [AccessType.STAFF],
    to: { name: 'AdminPersonList' }
  },
  {
    title: 'Training',
    icon: 'spellcheck',
    accessTypes: [AccessType.STAFF],
    items: [
      {
        title: 'Modules & Units',
        icon: 'view_module',
        to: { name: 'AdminTraining' }
      },
      {
        title: 'Sessions',
        icon: 'event',
        to: { name: 'AdminTrainingSessionList' }
      },
      {
        title: 'Trainees',
        icon: 'assignment_ind',
        to: { name: 'AdminTrainees' }
      },
      {
        title: 'Trainers',
        icon: 'supervisor_account',
        to: { name: 'AdminTrainers' }
      },
      {
        title: 'AUS-MEAT Trainees',
        icon: 'person_search',
        to: { name: 'AdminAusMeatTraineeList' }
      }
    ]
  },
  {
    title: 'System',
    icon: 'admin_panel_settings',
    accessTypes: [AccessType.STAFF],
    items: [
      {
        title: 'Member Types',
        icon: 'gavel',
        to: { name: 'AdminMemberTypeList' }
      },
      {
        title: 'Access Keys',
        icon: 'vpn_key',
        to: { name: 'AdminAccessKeys' }
      },
      {
        title: 'Graders',
        icon: 'engineering',
        to: { name: 'AdminGraderList' }
      },
      {
        title: 'Producer Sync',
        icon: 'cloud_sync',
        to: { name: 'AdminProducerList' }
      },
      {
        title: 'InfoSys Migration',
        icon: 'input',
        to: { name: 'AdminInfoSysMemberList' }
      },
      {
        title: 'Person Consolidation',
        icon: 'merge',
        to: { name: 'AdminPersonConsolidation' }
      }
    ]
  }
]

export default {
  name: 'Navigation',

  data: () => ({
    menuItems
  }),

  computed: {
    accessType () {
      return this.$auth.userProfile.access_type || AccessType.RESTRICTED
    },

    isAdmin () {
      return this.accessType === AccessType.ADMINISTRATOR
    }
  }
}
</script>
